/**
 * Implementación del repositorio de Product usando HTTP
 */

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env';
import { ProductRepository } from '@domain/repositories/product.repository';
import { ProductOption } from '@domain/models/product.model';
import { ProductOptionDto } from '@infra/dto/product.dto';
import { ProductMapper } from '@infra/mappers/product.mapper';

@Injectable({ providedIn: 'root' })
export class ProductRepositoryImpl implements ProductRepository {
  private http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getProductOptions(): Observable<ProductOption[]> {
    return this.http.get<ProductOptionDto[]>(`${this.baseUrl}/v1/products/select`).pipe(
      map(dtos => ProductMapper.toDomainList(dtos))
    );
  }
}

